import axios from '../config/axios';

export function apiGetStaticData(table) {
  return axios.get(`static-data/${table}`);
};

export function apiGetRolePage() {
  return axios.get('static-data/role-pages');
};